/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_6_MonthsInputs */

const en_val_6_months = /** @type {(inputs: Val_6_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 Months`)
};

const es_val_6_months = /** @type {(inputs: Val_6_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 Meses`)
};

const fr_val_6_months = /** @type {(inputs: Val_6_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 Mois`)
};

const de_val_6_months = /** @type {(inputs: Val_6_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 Monate`)
};

const ja_val_6_months = /** @type {(inputs: Val_6_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6ヶ月`)
};

const zh_val_6_months = /** @type {(inputs: Val_6_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 个月`)
};

const ar_val_6_months = /** @type {(inputs: Val_6_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 أشهر`)
};

const id_val_6_months = /** @type {(inputs: Val_6_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 Bulan`)
};

const it_val_6_months = /** @type {(inputs: Val_6_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 Mesi`)
};

const ru_val_6_months = /** @type {(inputs: Val_6_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 Месяцев`)
};

const pt_val_6_months = /** @type {(inputs: Val_6_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 Meses`)
};

const ko_val_6_months = /** @type {(inputs: Val_6_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6개월`)
};

/**
* | output |
* | --- |
* | "6 Months" |
*
* @param {Val_6_MonthsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_6_months = /** @type {((inputs?: Val_6_MonthsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_6_MonthsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_6_months(inputs)
	if (locale === "es") return es_val_6_months(inputs)
	if (locale === "fr") return fr_val_6_months(inputs)
	if (locale === "de") return de_val_6_months(inputs)
	if (locale === "ja") return ja_val_6_months(inputs)
	if (locale === "zh") return zh_val_6_months(inputs)
	if (locale === "ar") return ar_val_6_months(inputs)
	if (locale === "id") return id_val_6_months(inputs)
	if (locale === "it") return it_val_6_months(inputs)
	if (locale === "ru") return ru_val_6_months(inputs)
	if (locale === "pt") return pt_val_6_months(inputs)
	return ko_val_6_months(inputs)
});